import React from "react";
import { Grid, Button, Box, Typography } from "@mui/material";
import MenuIcon from "./../MenuIcon";
const LoginMenu = ({ isLoggedIn = false, loggedInUserName = "", onLoginClicked, onLogoutClicked, }) => {
    return (React.createElement(React.Fragment, null,
        React.createElement(Grid, { container: true, spacing: 2, direction: "row", sx: { minWidth: "200px" } },
            React.createElement(Grid, { item: true, key: "g-20", sx: { display: "flex", alignItems: "center" } },
                React.createElement(Box, { sx: { display: "flex", alignItems: "center" } },
                    React.createElement(MenuIcon, { iconName: "Grass" }),
                    !isLoggedIn ? (React.createElement(Button, { key: "g-20-1", "data-key": "g-20-1-1", onClick: onLoginClicked, sx: {
                            marginLeft: 1,
                            color: "#ffffff",
                        } }, "Login")) : (React.createElement(Box, { sx: { display: "flex", alignItems: "center" } },
                        React.createElement(Typography, { variant: "body2" },
                            "Logged in as: ",
                            loggedInUserName,
                            "\u00A0"),
                        React.createElement(Button, { key: "g-21-1", "data-key": "g-21-1-1", onClick: onLogoutClicked, sx: {
                                marginLeft: 1,
                                color: "#ffffff",
                            } }, "Logout"))))))));
};
export default LoginMenu;
